var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"pb-2 text-gray-600 whitespace-nowrap",attrs:{"to":{name: _vm.tab.name},"active-class":"title-tab-active"}},[_vm._v("\n    "+_vm._s(_vm.tab.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }